<template>
  <!-- 상품하단 정보 탭 -->
  <div class="tabWrap hr">
    <ul class="tabList pageTab" id="prd_detail_tab2">
      <li class="on">상품정보</li>
      <li @click="middleTab(1)">
        리뷰/문의
        <span class="pointC1">({{ (reviewSummary.totalReviewCount + qnaTotalCount) | numberAddPlus }})</span>
      </li>
      <li>렌탈안내</li>
      <li>제품사양</li>
    </ul>
    <div class="tabContents">
      <!-- 상품정보 -->
      <div class="tabPanel">
        <div class="detailWrap">
          <div class="inner">
            <template v-if="product.image">
              <span class="img" v-html="product.image.replace(/\\/g, '')">
                <!--<img src="../../../../static/img/mw/content/img_goods_detail01.png" alt="상품정보">-->
              </span>
            </template>
          </div>
          <button type="button" class="btnMore" id="prd_detail_more" @click="btnProductMore()"><span>상품정보 더보기</span></button>
        </div>
      </div>

      <!-- 후기/문의 -->
      <div class="tabPanel">
        <div class="reviewWrap">
          <div class="reviewRate" v-if="reviewSummary.totalReviewCount > 0">
            <p class="desc">
              <em v-if="userInfo">
                30대
                <template v-if="userInfo.sex != ''">{{ userInfo.sex }}성이</template>
                <template v-else>여성이</template>
              </em>
              <em v-else>30대 여성이</em>
              제일 많이 구매했어요!
            </p>
            <div class="ratingWrap">
              <span class="point">{{ reviewSummary.averageScore }}</span>
              <span class="starRating">
                <span :style="{ width: Number(reviewSummary.averageScore) * 20 + '%' }"></span>
              </span>
            </div>
          </div>

          <div class="reviewRate" v-else>
            <!-- 후기가 없을 경우(s)-->
            <p class="desc">리뷰가 아직 없네요!</p>
            <div class="ratingWrap">
              <span class="point pointC6">0.0</span>
              <span class="starRating">
                <span style="width: 0%"></span>
              </span>
            </div>
            <!-- 후기가 없을 경우(e)-->
          </div>

          <div class="photoReview" v-if="reviewSummary.photoReviewCount > 0">
            <div class="titArea">
              <h2 class="titH5">
                포토리뷰(
                <span>{{ reviewSummary.photoReviewCount | numberAddPlus }}</span>
                )
              </h2>
            </div>
            <div class="slide" id="review_thumlist">
              <ul class="slideList">
                <li v-for="(reviewPhoto, index) in reviewPhotoList" :key="index">
                  <a href="javascript:void(0);" class="block" @click="btnShowReviewPhotoDetail(index)">
                    <span class="img">
                      <img :src="reviewPhoto.photoPath.urls[0]" alt="" />
                      <em class="imgNum" v-if="reviewPhoto.photoPath.urls.length > 1">
                        <span class="blind">사진 수</span>
                        {{ reviewPhoto.photoPath.urls.length }}
                      </em>
                    </span>
                  </a>
                </li>
              </ul>
              <div class="swiper-scrollbar"></div>
            </div>
          </div>

          <div class="reviewTop">
            <h3 class="titH5">
              전체리뷰(
              <span>{{ reviewInfo.totalElements }}</span>
              )
            </h3>
            <button type="button" class="btn_s s round fr" @click="openReviewInsertPop()">리뷰쓰기</button>
          </div>
          <template v-if="reviewList.length > 0">
            <ul class="reviewList">
              <li v-for="(review, index) in reviewList" :key="index">
                <a href="javascript:void(0);" class="inner">
                  <div class="topArea">
                    <div class="ratingWrap">
                      <span class="starRating">
                        <span :style="{ width: review.averageScore * 20 + '%' }"></span>
                      </span>
                      <span class="user">{{ review.writer }}</span>
                      <span v-if="review.writerAge != ''">{{ review.writerAge }}대</span>
                      <span v-if="review.writerSex != ''">{{ review.writerSex }}성</span>
                    </div>
                    <span class="date">{{ review.createDate }}</span>
                  </div>
                  <p class="cont">{{ review.contents }}</p>
                </a>
                <template v-for="(photo, index) in review.photos">
                  <span class="img" :key="index" @click="showReviewSinglePhoto(photo)">
                    <img
                      :key="index"
                      :src="`data:image/${photo.fileTpMCntn === 'jpg' ? 'jpeg' : photo.fileTpMCntn};base64,${photo.file}`"
                      style="padding-top: 10px"
                    />
                  </span>
                  <!--
                  <span class="img" :key="index" @click="showReviewSinglePhoto(photoUrl)">
                    <img :src="photoUrl" alt="" />
                  </span>
                  -->
                </template>
              </li>
            </ul>
            <div class="btnArea" v-if="reviewCurrentPage < reviewTotalPage">
              <button type="button" class="btnMore" @click="selectReviewListMore()">
                <span>{{ reviewPageSize }}개 더보기</span>
              </button>
            </div>
          </template>

          <!-- 후기가 없을 경우(s)-->
          <p class="noData" v-else>등록된 상품 리뷰가 없습니다.</p>
          <!-- 후기가 없을 경우(e)-->
        </div>

        <div class="reviewWrap">
          <div class="reviewTop">
            <h3 class="titH5">
              상품문의(
              <span>{{ qnaTotalCount | currency }}</span>
              )
            </h3>
            <button type="button" class="btn_s s round fr" @click="openQnaInsertPop()">문의하기</button>
          </div>
          <template v-if="qnaList.length > 0">
            <ul class="inquireList">
              <li v-for="(prodQna, index) in qnaList" :key="index">
                <div class="accoHead">
                  <div class="inquireArea">
                    <div class="tit" v-if="prodQna.qna.hiddenQna"><span class="private" style="color: #999">비공개 글입니다.</span></div>
                    <div class="tit" v-else>{{ prodQna.qna.contents }}</div>
                    <div class="disc">
                      <span :class="{ pointC1: prodQna.qna.reply.replyDate != '' }" v-if="prodQna.qna.reply.replyDate != ''">답변완료</span>
                      <span v-else>답변대기</span>

                      <span>{{ prodQna.qna.writeDate.substring(0, 10) }}</span>
                      <span>{{ prodQna.qna.writer }}</span>
                    </div>
                  </div>
                  <a class="accoBtn" v-if="prodQna.qna.reply.replyDate != ''">
                    <span class="btnIco_acco"><span>상세보기</span></span>
                  </a>
                </div>
                <div class="accoBody">
                  <div class="answerArea">
                    <div class="answerBox">
                      {{ prodQna.qna.reply.contents }}
                      <p class="date">{{ prodQna.qna.reply.replyDate }}</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <!--<div class="btnArea">-->
            <!--<button type="button" class="btnMore" @click="qnaSearchMore()" v-show="qnaMoreBtn"><span>더보기</span></button>-->
            <!--</div>-->
            <div class="btnArea" v-if="qnaCurrentPage < qnaTotalPage">
              <button type="button" class="btnMore" @click="selectQnaListMore()">
                <span>{{ qnaPageSize }}개 더보기</span>
              </button>
            </div>
          </template>

          <!-- 문의가 없을 경우(s)-->
          <p class="noData" v-else>등록된 상품 문의가 없습니다.</p>
          <!-- 문의가 없을 경우(e)-->
        </div>
      </div>

      <!-- 렌탈안내 -->
      <div class="tabPanel">
        <section class="full" id="info_buy1">
          <span class="img">
            <div class="tempArea" v-html="productCommon.commonInfo"></div>
          </span>
        </section>
        <section class="full" id="info_buy2">
          <span class="img">
            <div class="tempArea"><img :src="productCommon.rentalCommonInfo" /></div>
          </span>
        </section>
      </div>

      <!-- 제품사양 -->
      <div class="tabPanel crm_frod_info on" id="panel_1_3" role="tabpanel" aria-hidden="false" aria-labelledby="tab_1_3">
        <section class="full">
          <div class="tbWrap state">
            <div class="crm_tit crm_tit01"><span>스펙 정보</span></div>
            <table class="tableY crm_table01 clearfix">
              <!-- <colgroup>
                  <col style="width: 100%" />
                  <col style="width: 100%" />
                </colgroup> -->

              <tbody>
                <tr v-if="product.model != ''" class="crm_a_tr01">
                  <td class="th first">모델명</td>
                  <td v-html="product.model"></td>
                </tr>
                <tr v-if="product.volume != ''" class="crm_a_tr02">
                  <td class="th first">용량</td>
                  <td v-html="product.volume"></td>
                </tr>
                <tr v-if="product.area != ''" class="crm_a_tr02">
                  <td class="th first">평형(면적)</td>
                  <td v-html="product.area"></td>
                </tr>
                <tr v-if="product.spec != ''" class="crm_a_tr03">
                  <td class="th first">사양</td>
                  <td v-html="product.spec"></td>
                </tr>
                <tr v-if="product.func != ''" class="crm_a_tr04">
                  <td class="th first">기능</td>
                  <td v-html="product.func"></td>
                </tr>
                <tr v-if="product.compo != ''" class="crm_a_tr05">
                  <td class="th first">구성</td>
                  <td v-html="product.compo"></td>
                </tr>
                <tr v-if="product.material != ''" class="crm_a_tr06">
                  <td class="th first">소재</td>
                  <td v-html="product.material"></td>
                </tr>
                <tr v-if="product.purpose != ''" class="crm_a_tr07">
                  <td class="th first">사용목적</td>
                  <td v-html="product.purpose"></td>
                </tr>
                <tr v-if="product.usage != ''" class="crm_a_tr08">
                  <td class="th first">사용방법</td>
                  <td v-html="product.usage"></td>
                </tr>
                <tr v-if="product.color" class="crm_a_tr09">
                  <td class="th first">색상</td>
                  <td v-html="product.color"></td>
                </tr>
                <tr v-if="product.size" class="crm_a_tr10">
                  <td class="th first">크기(가로x세로x높이)</td>
                  <td v-html="product.size"></td>
                </tr>
                <tr v-if="product.weight" class="crm_a_tr11">
                  <td class="th first">무게</td>
                  <td v-html="product.weight"></td>
                </tr>
                <tr v-if="product.installtype != ''" class="crm_a_tr12">
                  <td class="th first">설치형태</td>
                  <td v-html="product.installtype"></td>
                </tr>
                <tr v-if="product.ratedvolt != ''" class="crm_a_tr13">
                  <td class="th first">정격전압</td>
                  <td v-html="product.ratedvolt"></td>
                </tr>
                <tr v-if="product.elecconsume != ''" class="crm_a_tr14">
                  <td class="th first">소비전력</td>
                  <td v-html="product.elecconsume"></td>
                </tr>
                <tr v-if="product.energyefficiency != ''" class="crm_a_tr15">
                  <td class="th first">에너지효율등급</td>
                  <td v-html="product.energyefficiency"></td>
                </tr>
                <tr v-if="product.kcnum != ''" class="crm_a_tr16">
                  <td class="th first">KC인증번호</td>
                  <td>
                    <span v-html="product.kcnum">asd</span>
                    <span class="kc_mark"></span>
                  </td>
                </tr>
                <tr v-if="product.mwnum != ''" class="crm_a_tr17">
                  <td class="th first">전자파인증번호</td>
                  <td v-html="product.mwnum"></td>
                </tr>
                <tr v-if="product.medinum != ''" class="crm_a_tr18">
                  <td class="th first">의료기기인증</td>
                  <td v-html="product.medinum"></td>
                </tr>
                <tr v-if="product.addiauth != ''" class="crm_a_tr19">
                  <td class="th first">추가인증</td>
                  <td v-html="product.addiauth"></td>
                </tr>
                <tr v-if="product.prdtname != ''" class="crm_a_tr20">
                  <td class="th first">제품명칭</td>
                  <td v-html="product.prdtname"></td>
                </tr>
                <tr v-if="product.releasedate != ''" class="crm_a_tr21">
                  <td class="th first">동일모델의 출시년월</td>
                  <td v-html="product.releasedate"></td>
                </tr>
                <tr v-if="product.brand" class="crm_a_tr22">
                  <td class="th first">브랜드</td>
                  <td v-html="product.brand"></td>
                </tr>
                <tr v-if="product.manufacturer" class="crm_a_tr23">
                  <td class="th first">제조사</td>
                  <td v-html="product.manufacturer"></td>
                </tr>
                <tr v-if="product.manufacturernation != ''" class="crm_a_tr24">
                  <td class="th first">제조국</td>
                  <td v-html="product.manufacturernation"></td>
                </tr>
                <tr v-if="product.insure" class="crm_a_tr25">
                  <td class="th first">품질보증기준</td>
                  <td v-html="product.insure"></td>
                </tr>
                <tr v-if="product.asnum" class="crm_a_tr26">
                  <td class="th first">A/S 책임자와 전화번호</td>
                  <td v-html="product.asnum"></td>
                </tr>
              </tbody>
            </table>
            <div class="crm_tit crm_tit02"><span>구매 및 납입 정보</span></div>
            <table class="tableY crm_table02 clearfix">
              <!-- <colgroup>
                  <col style="width: 100%;">
                  <col style="width: 100%;">
                </colgroup> -->

              <tbody>
                <tr class="custom_tr_half crm_b_tr01">
                  <td class="th first">구매방식</td>
                  <td>
                    <span v-if="product.buy == '1'" class="crm_buy crm_buy01">
                      구매
                      <!-- <em>(APP전용)</em> -->
                    </span>
                    <span v-if="product.installment == '1'" class="crm_buy crm_buy02">장기할부</span>
                    <span v-if="product.rental == '1'" class="crm_buy crm_buy03">렌탈</span>
                  </td>
                </tr>
                <tr v-if="product.usePeriod" class="crm_b_tr02">
                  <td class="th first">의무사용기간</td>
                  <td v-html="product.usePeriod" class="td_add_txt"></td>
                </tr>
                <tr v-if="product.cycle" class="crm_b_tr03">
                  <td class="th first">관리주기</td>
                  <td v-html="product.cycle" class="td_add_txt"></td>
                </tr>
                <tr v-if="product.deliveryType" class="crm_b_tr04">
                  <td class="th first">배송형태</td>
                  <td v-html="product.deliveryType"></td>
                </tr>
                <tr v-if="product.deliveryFee" class="crm_b_tr05">
                  <td class="th first">배송비</td>
                  <td v-html="product.deliveryFee"></td>
                </tr>
                <tr v-if="product.installFee" class="crm_b_tr06">
                  <td class="th first">설치비</td>
                  <td v-html="product.installFee"></td>
                </tr>
              </tbody>
            </table>
            <span v-if="product.rental == '1' || product.installment == '1'">
              <div class="crm_tit crm_tit02 s_tit"><span>소유권이전 안내(렌탈 및 장기할부 시)</span></div>
              <table class="tableY crm_table02 clearfix">
                <!-- <colgroup>
                  <col style="width: 100%;">
                  <col style="width: 100%;">
                </colgroup> -->

                <tbody>
                  <tr v-if="product.usePeriod">
                    <td class="th first">약정 조건</td>
                    <td v-html="product.usePeriod"></td>
                  </tr>
                  <tr v-if="product.ownership">
                    <td class="th first">소유권이전 시기</td>
                    <td v-html="product.ownership"></td>
                  </tr>
                </tbody>
              </table>
            </span>

            <span v-show="product.installment == '1'">
              <div class="crm_tit crm_tit02 s_tit s_tit_deco"><span>기타 비용 및 상품의 고장·훼손 관련 안내 (장기할부)</span></div>
              <table class="tableY crm_table02 clearfix" style="margin: 0 0 10px">
                <!-- <colgroup>
                    <col style="width: 100%;">
                    <col style="width: 100%;">
                  </colgroup> -->

                <tbody>
                  <td style="padding: 0">
                    <div class="crm_tb crm_tb_top_explain">
                      <div class="crm_art" style="border: 0">유형</div>
                      <div class="crm_art" style="border: 0">비용</div>
                    </div>

                    <div v-show="product.cancelbeforeopen" class="crm_tb crm_tb_mid">
                      <div class="crm_art">제품 설치 및 박스 개봉 전 7일 이내 청약철회 시</div>
                      <div class="crm_art" v-html="product.cancelbeforeopen"></div>
                    </div>
                    <div class="crm_tb crm_tb_mid">
                      <div class="crm_art">소비자의 책임 없는 사유로 상품의 고장, 훼손 시</div>
                      <div class="crm_art">무상(수리비 및 부품 교환)</div>
                    </div>
                    <div class="crm_tb crm_tb_mid">
                      <div class="crm_art">소비자의 귀책으로 인한 상품의 고장, 훼손 시</div>
                      <div class="crm_art">소비자 부담(출장비 + 수리비 및 부품 교환 비용)</div>
                    </div>
                  </td>
                </tbody>
              </table>
            </span>

            <span v-show="product.rental == '1'">
              <div class="crm_tit crm_tit02 s_tit s_tit_deco"><span>기타 비용 및 상품의 고장·훼손 관련 안내 (렌탈)</span></div>
              <table class="tableY crm_table02 clearfix" style="margin: 0 0 10px">
                <!-- <colgroup>
                      <col style="width: 100%" />
                      <col style="width: 100%" />
                  </colgroup> -->

                <tbody>
                  <td style="padding: 0">
                    <div class="crm_tb crm_tb_top_explain">
                      <div class="crm_art" style="border: 0">유형</div>
                      <div class="crm_art" style="border: 0">비용</div>
                    </div>
                    <div v-show="product.cancelafterinstall" class="crm_tb crm_tb_mid">
                      <div class="crm_art">제품 설치 후 14일 이내 중도 해약 시 위약금 (제품반납 조건)</div>
                      <div class="crm_art" v-html="product.cancelafterinstall"></div>
                    </div>
                    <div class="crm_tb crm_tb_mid">
                      <div class="crm_art">제품 설치 후 14일 이후 중도 해약 시 위약금 (제품반납 조건)</div>
                      <div class="crm_art">
                        미납 렌탈료 + 연체이자 + 잔여 렌탈료 합계의 30% + 렌탈 등록비 + 제품 회수비 + 프로모션 혜택 비용(해당 시) + 사은품 혜택
                        비용(해당 시)
                      </div>
                    </div>
                    <div class="crm_tb crm_tb_mid">
                      <div class="crm_art">제품 분실, 파손, 고장, 구성품이 전부 반납되지 않을 시 위약금</div>
                      <div class="crm_art">
                        미납 렌탈료 + 연체이자 + 잔여 렌탈료(전액) + 렌탈 등록비 + 프로모션 혜택 비용(해당 시) + 사은품 혜택 비용(해당 시)
                      </div>
                    </div>
                  </td>
                </tbody>
              </table>
            </span>

            <table class="tableY crm_table02 clearfix">
              <!-- <colgroup>
                  <col style="width: 100%" />
                  <col style="width: 100%" />
                </colgroup> -->

              <tbody v-if="specifications.length != 0">
                <tr class="custom_tr">
                  <td class="th first">특이사항(추가 배송비, 추가 설치비 등)</td>
                  <td class="crm_custom_td">
                    <div v-for="(item, index) in specifications" :key="index" class="crm_tb crm_tb_mid">
                      <div class="crm_art accent" v-html="item.title"></div>
                      <div class="crm_art" v-html="item.content"></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="tableY crm_table02 clearfix">
              <!-- <colgroup>
                <col style="width: 100%;">
                <col style="width: 100%;">
              </colgroup> -->

              <tbody>
                <tr class="custom_tr">
                  <td class="th first">거래 조건에 관한 정보</td>

                  <div class="crm_tb crm_tb_mid" v-if="product.deliveryType">
                    <div class="crm_art bo_2px accent">재화 등의 배송 방법에 관한 정보</div>
                    <div class="crm_art bo_2px" v-html="product.deliveryType"></div>
                  </div>
                  <div class="crm_tb crm_tb_mid">
                    <div class="crm_art accent">주문 이후 예상되는 배송기간</div>
                    <div class="crm_art">대금 지급일로부터 7일 이내에 발송. 단, 배송일자를 협의한 날짜에는 그에 따름</div>
                  </div>
                  <div class="crm_tb crm_tb_mid">
                    <div class="crm_art accent">
                      제품 하자가 아닌 소비자의 단순 변심, 착오 구매에 따른 청약철회 시 소비자가 부담하는 반품비용 등에 관한 정보
                    </div>
                    <div class="crm_art">
                      전자상거래 등에서의 소비자보호에 관한 법률 등에 의한 청약철회 제한 사유에 해당하는 경우 및 기타 객관적으로 이에 준하는 것으로
                      인정되는 경우 청약철회가 제한될 수 있습니다.
                    </div>
                  </div>
                  <div class="crm_tb crm_tb_mid">
                    <div class="crm_art accent">
                      제품 하자, 오배송 등에 따른 청약철회 등의 경우 청약철회 등을 할 수 있는 기간 및 통신판매업자가 부담하는 반품비용 등에 관한 정보
                    </div>
                    <div class="crm_art">
                      전자상거래 등에서의 소비자보호에 관한 법률 등에 의한 제품 하자 또는 오배송 등으로 인한 청약철회의 경우에는 상품 수령 후 3개월
                      이내, 그 사실을 안 날 또는 알 수 있었던 날로부터 30일 이내에 청약철회를 할 수 있으며, 반품 비용은 통신판매업자가 부담합니다.
                    </div>
                  </div>
                  <div class="crm_tb crm_tb_mid">
                    <div class="crm_art accent">재화 등의 교환·반품·보증 조건 및 품질보증 기준</div>
                    <div class="crm_art">소비자 분쟁 해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.</div>
                  </div>
                  <!-- <div class="crm_tb crm_tb_mid">
                        <div class="crm_art accent">재화 등의 A/S 관련 전화번호</div>
                        <div class="crm_art">웰릭스렌탈 고객센터 1670-0202</div>
                      </div> -->
                  <div class="crm_tb crm_tb_mid">
                    <div class="crm_art accent">
                      대금을 환불받기 위한 방법과 환불이 지연될 경우 지연에 따른 배상금을 지급받을 수 있다는 사실 및 배상금 지급의 구체적 조전 및 절차
                    </div>
                    <div class="crm_art">
                      주문취소 및 대금의 환불은 고객센터에 전화로 신청할 수 있으며, 전자상거래 등에서의 소비자보호에 관한 법률에 따라 소비자의
                      청약철회 후 판매자가 재화 등을 반환받은 날로부터 3영업일 이내에 지급받은 대금의 환급을 정당한 사유 없이 지연하는 때에는 소비자는
                      지연 기간에 대해서 연 15%의 지연배상금을 판매자에게 청구할 수 있습니다.
                    </div>
                  </div>
                  <div class="crm_tb crm_tb_mid">
                    <div class="crm_art accent">소비자 피해 보상의 처리, 재화 등에 대한 불만 처리 및 소비자와 사업자 사이의 분쟁처리에 관한 사항</div>
                    <div class="crm_art">소비자 분쟁 해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.</div>
                  </div>
                  <div class="crm_tb crm_tb_mid">
                    <div class="crm_art accent">거래에 관한 약관의 내용 또는 확인할 수 있는 방법</div>
                    <div class="crm_art">회사의 약관에 따릅니다.</div>
                  </div>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
    <!-- 포토후기 팝업 -->
    <ReviewPhotoPop
      v-if="reviewPhotoPop"
      :reviewSummary="reviewSummary"
      :reviewPhotoList="reviewPhotoList"
      :reviewPhotoLengthList="reviewPhotoLengthList"
      :currentReviewPhotoIdx="currentReviewPhotoIdx"
      @close="closeReviewPhotoPop"
    ></ReviewPhotoPop>
    <ReviewSinglePhotoPop v-if="reviewSinglePhotoPop" :reviewPhoto="reviewPhoto" @close="closeReviewSinglePhotoPop"></ReviewSinglePhotoPop>
    <MessagePop v-if="messagePop" @close="messagePop = false"><p v-html="msg"></p></MessagePop>
    <ConfirmPop v-if="confirmPop" @confirm="confirm" @cancel="confirmPop = false" @close="confirmPop = false"><p v-html="msg"></p></ConfirmPop>
    <!-- 리뷰 작성 -->
    <MyReviewInsertPop v-if="myReviewInsertPop" @close="myReviewInsertPop = false" :propsReviewObj="reviewObj" :imgList="imgList"></MyReviewInsertPop>
    <!-- Qna 작성 -->
    <ProductQnaInsertPop v-if="productQnaInsertPop" @close="qnaInsertPopClose" :propsProdQna="prodQna"></ProductQnaInsertPop>
  </div>
</template>
<style>
/* 스펙 정보 */
.crm_frod_info {
  letter-spacing: -0.085em;
}
.crm_frod_info .crm_tit {
  font-size: 1.9rem;
  padding: 5px 0px 20px;
  border-bottom: 2px solid #333;
  margin-bottom: 25px;
  font-family: 'NotoSans Bold';
  font-weight: 700;
}
.crm_frod_info .crm_tit02 {
  border-top: 0px solid #f2f4f5;
  padding: 30px 0px 20px;
}

.crm_frod_info .crm_table01 {
  width: 100%;
  display: flex;
}
.crm_frod_info .crm_table01 tr {
  width: 50%;
  float: left;
  margin-top: 0;
  margin-bottom: 20px;
  min-height: 82px;
}
.crm_frod_info .crm_table01 td {
  width: 100%;
  display: inline-block;
  font-size: 1.5rem;
  color: #333;
  border: 0;
  padding: 5px 12px 5px;
  font-family: 'NotoSans Bold';
  font-weight: 700;
}
.crm_frod_info .crm_table01 td.first {
  background-color: #fff;
  font-size: 1.3rem;
  color: #909090;
}
.crm_frod_info .crm_table01 tr:first-child td,
.crm_frod_info .crm_table01 tr:first-child th {
  border: 0;
}

.crm_frod_info .kc_mark {
  margin-left: 10px;
  position: relative;
  width: 16px;
}
.crm_frod_info .kc_mark::after {
  content: '';
  position: absolute;
  top: -3px;
  left: 0;
  background: url('https://www.welrix.com/img_1/welmall_comm_img/1669701061856_kc_mark.png') no-repeat;
  background-size: 16px 25px;
  width: 16px;
  height: 25px;
}

/* 구입 및 납입 정보 */
.crm_frod_info .crm_table02 {
  width: 100%;
}
.crm_frod_info .crm_table02 tr {
  width: 50%;
  float: left;
  margin-top: 0;
  margin-bottom: 30px;
}
.crm_frod_info .crm_table02 td {
  width: 100%;
  display: inline-block;
  font-size: 1.3rem;
  color: #666;
  border: 0;
  padding: 5px 12px 5px;
}
.crm_frod_info .crm_table02 td.first {
  background-color: #fff;
  font-size: 1.5rem;
  color: #333;
  font-family: 'NotoSans Bold';
  font-weight: 700;
}
.crm_frod_info .crm_table02 tr:first-child td,
.crm_frod_info .crm_table02 tr:first-child th {
  border: 0;
}

.crm_frod_info .crm_table02 td .crm_buy {
  border: 1px solid #333;
  color: #333;
  border-radius: 3px;
  padding: 1px 8px 3px;
  margin-right: 5px;
}
.crm_frod_info .crm_table02 td .crm_buy em {
  font-style: normal;
  font-size: 0.5rem;
}

.crm_frod_info .crm_table02 .custom_tr {
  width: 100%;
  margin-top: 20px;
}
.crm_frod_info .crm_table02 .custom_tr_half {
  width: 50%;
}
.crm_frod_info .crm_table02 .custom_tr td {
  padding: 5px 0px 5px;
}

.crm_tb {
  display: flex;
}
.crm_tb .crm_art {
  width: 50%;
  padding: 20px 12px;
  border-top: 1px solid #ddd;
  font-size: 1.5rem;
}
.crm_tb_mid .crm_art {
  font-size: 1.3rem;
  color: #666;
}
.crm_tb .bo_2px {
  border-top: 2px solid #333;
}
.crm_tb .crm_art .crm_obj {
  width: 100%;
  display: inline-block;
  position: relative;
  padding-left: 10px;
}
.crm_tb .crm_art .crm_obj::before {
  content: '-';
  position: absolute;
  left: 0;
  top: 0;
}
.crm_tb_top_explain {
  color: #333;
  font-weight: bold;
  font-size: 1.5rem;
}
.crm_tb_top {
  color: #333;
  font-weight: bold;
  font-size: 1.5rem;
  border-top: 2px solid #333;
}

.crm_tb_top .crm_art {
  border-top: 0;
}
.crm_tb_mid {
}
.crm_tb .tit {
  font-weight: bold;
  color: #333;
  font-size: 1.5rem;
}
.crm_frod_info .accent {
  color: #333;
  font-weight: bold;
}

.crm_frod_info .s_tit {
  font-size: 1.5rem;
  padding: 40px 0 5px;
}

.crm_frod_info .crm_table02 td .add_txt {
  font-size: 1rem;
}

.crm_frod_info .s_tit_deco {
  margin-bottom: 0;
}

.crm_custom_td .crm_tb_mid:nth-child(1) .crm_art {
  border-top: 2px solid #333;
}

.td_add_txt {
  position: relative;
}
.td_add_txt::after {
  content: '*구매 시 해당사항 없음.';
  font-size: 10px;
  position: absolute;
  left: 12px;
  bottom: -12px;
}

/* .crm_frod_info .crm_table02{width: 100%; display: flex;}
  .crm_frod_info .crm_table02 tr{width: 50%; margin-top: 0px; min-height: 80px;}
  .crm_frod_info .crm_table02 th{display: block; width: 100% !important; border: 0 !important; background: #fff; padding: 5px 10px 5px 10px !important; font-size: 1.5rem; color: #333; font-weight: bold !important;}
  .crm_frod_info .crm_table02 td{display: block; width: 100% !important; border: 0 !important; background: #fff; padding: 5px 10px 5px 10px !important; font-size: 1.3rem; color: #909090;}

  .crm_frod_info .crm_table02 td .crm_buy{border: 1px solid #333; color: #333; border-radius: 6px; padding: 1px 10px 3px; margin-right: 5px;}
  .crm_frod_info .crm_table02 td .crm_buy em{font-style: normal; font-size: 11px;}
  .crm_frod_info .crm_table02 td .crm_buy03{display: none;}


  .crm_frod_info .crm_table02 .custom_tr{width: 100%; margin-top: 20px;}
  .crm_frod_info .crm_table02 .custom_tr_half{width: 50%;}

  .crm_tb{display: flex;}
  .crm_tb .crm_art{width: 50%; padding: 20px 10px; border-top: 1px solid #ddd; font-size: 16px;}
  .crm_tb .bo_2px{border-top: 2px solid #333;}
  .crm_tb .crm_art .crm_obj{width: 100%; display: inline-block; position: relative; padding-left: 10px;}
  .crm_tb .crm_art .crm_obj::before{content: '-'; position: absolute; left: 0; top: 0;}

  .crm_tb_top{color: #333; font-weight: bold; font-size: 16px; border-top: 2px solid #333;}
  .crm_tb_top .crm_art{border-top: 0;}
  .crm_tb_mid{}
  .crm_tb .tit{font-weight: bold; color: #333;} */
</style>

<script>
import * as customjs from '@/../static/js/m.front.js';
import { LOGIN_REQUIRE } from '@/store/message.type.js';
import $ from 'jquery';
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import ConfirmPop from '@/components/popup/ConfirmPop';
import MessagePop from '@/components/popup/MessagePop';
import ReviewPhotoPop from '@/views/app/product/ReviewPhotoPop';
import ReviewSinglePhotoPop from '@/views/app/product/ReviewSinglePhotoPop';
import MyReviewInsertPop from '@/views/app/mypage/review/MyReviewInsertPop';
import ProductQnaInsertPop from '@/views/app/product/ProductQnaInsertPop';

export default {
  name: 'ProductDetailTab',
  props: ['productCode', 'product', 'productCommon', 'reviewSummary', 'reviewObj', 'specifications'],
  components: { MessagePop, ConfirmPop, ReviewPhotoPop, ReviewSinglePhotoPop, MyReviewInsertPop, ProductQnaInsertPop },
  data() {
    return {
      userInfo: JwtService.getUserInfo(), // 로그인 사용자 정보

      msg: '',
      messagePop: false,
      confirmPop: false,
      reviewPhotoPop: false,
      reviewSinglePhotoPop: false,
      myReviewInsertPop: false,
      productQnaInsertPop: false,

      reviewInfo: [],
      reviewList: [],
      reviewPhotoList: [],
      reviewPhoto: '',

      qnaList: [],
      prodQna: {
        productInfo: {
          product: {
            productIndex: '',
          },
        },
        qna: {
          qnaId: false,
        },
      },

      reviewCurrentPage: 1,
      reviewPageSize: 10,
      reviewTotalPage: 0,
      reviewPhotoInfo: [],
      reviewPhotoLengthList: [],

      currentReviewPhotoIdx: 0,
      productProps: this.product,

      // qnaSize: 10,
      qnaCurrentPage: 1,
      qnaPageSize: 10,
      qnaTotalPage: 0,
      qnaTotalCount: 0,
      // qnaMoreBtn: true,

      imgList: [],
    };
  },
  mounted() {
    // customjs.init();
    this.selectReviewPhotoList(); // 포토 리뷰 리스트 조회
    this.selectReviewList(); // 리뷰 리스트 조회
    this.selectQnaList(); // QnA 리스트 조회
    this.middleTab(1); // 포토 리뷰 관련 초기화
  },
  updated() {
    customjs.accoInit();
    customjs.addStiky('#prd_detail_tab2');
  },
  created() {
    window.sangjoEvent = this.sangjoEvent.bind(this);
  },
  methods: {
    // 리뷰 리스트 조회
    selectReviewList() {
      ApiService.service('GET', '/product/' + this.productCode + '/review?page=' + this.reviewCurrentPage + '&size=' + this.reviewPageSize)
        .then(({ data }) => {
          this.reviewList = data.result.content;
          this.reviewInfo = data.result;
          this.reviewTotalPage = data.result.totalPages;

          this.reviewList.forEach((data) => {
            if (data.fileMngId != null && data.fileMngId != '') {
              const files = [];
              ApiService.service('GET', 'common/downloadFile/' + data.fileMngId)
                .then(({ data }) => {
                  if (data.isSucceed) {
                    data.result.forEach((item) => {
                      const fileTpMCntn = item.exstFileLNm.split('.');
                      if (typeof item.file === 'string') {
                        item = {
                          ...item,
                          file: item.file,
                          fileTpMCntn: item.fileTpMCntn ? item.fileTpMCntn.trim() : fileTpMCntn[fileTpMCntn.length - 1].trim(),
                          exstFileLNm: item.exstFileLNm.trim(),
                          keyname: item.keyname.trim(),
                        };
                        files.push(item);
                      }
                    });
                  }
                })
                .catch(({ response }) => {
                  console.log('error : ' + response);
                })
                .finally(() => {
                  data.photos = [...files];
                });
            }
          });
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    // 리뷰 더보기
    selectReviewListMore() {
      ApiService.service('GET', '/product/' + this.productCode + '/review?page=' + (this.reviewCurrentPage + 1) + '&size=' + this.reviewPageSize)
        .then(({ data }) => {
          for (let value of data.result.content) {
            this.reviewList.push(value);
          }

          this.reviewCurrentPage++;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    // 포토 리뷰 리스트 조회
    selectReviewPhotoList() {
      ApiService.service('GET', '/product/' + this.productCode + '/review/photo')
        .then(({ data }) => {
          this.reviewPhotoList = data.result.content;
          this.reviewPhotoLengthList = [];
          for (let reviewPhoto of this.reviewPhotoList) {
            this.reviewPhotoLengthList.push(reviewPhoto.photoPath.urls.length);
          }
          /*this.reviewPhotoList.forEach(data => {
            if (data.fileMngId != null && data.fileMngId != '') {
              const files = [];
              ApiService.service('GET', 'common/downloadFile/' + data.fileMngId)
                .then(({ data }) => {
                  console.log(data);
                  if (data.isSucceed) {
                    //this.photoList = [...data.result];
                    data.result.forEach(item => {
                      console.log('file >> ');
                      console.log(item);
                      console.log('========================');

                      const fileTpMCntn = item.exstFileLNm.split('.');
                      if (typeof item.file === 'string') {
                        item = {
                          ...item,
                          file: item.file,
                          fileTpMCntn: item.fileTpMCntn ? item.fileTpMCntn.trim() : fileTpMCntn[fileTpMCntn.length - 1].trim(),
                          exstFileLNm: item.exstFileLNm.trim(),
                          keyname: item.keyname.trim(),
                        };
                        files.push(item);
                      }
                    });
                  }
                })
                .catch(({ response }) => {
                  console.log('error : ' + response);
                })
                .finally(() => {
                  data.photos = [...files];
                  this.reviewPhotoLengthList.push = [...files].length;
                });
            }
          }); */
          this.$parent.showSection();
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    // QnA 리스트 조회
    selectQnaList() {
      ApiService.service('GET', '/product/' + this.product.productCode + '/qnas?page=' + this.qnaCurrentPage + '&size=' + this.qnaPageSize)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.qnaTotalCount = data.result.totalElements;
            this.qnaTotalPage = data.result.totalPages;
            this.qnaList = null;
            this.qnaList = data.result.content;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    // QnA 더보기
    selectQnaListMore() {
      ApiService.service('GET', '/product/' + this.product.productCode + '/qnas?page=' + (this.qnaCurrentPage + 1) + '&size=' + this.qnaPageSize)
        .then(({ data }) => {
          for (let value of data.result.content) {
            this.qnaList.push(value);
          }

          this.qnaCurrentPage++;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    middleTab(idx) {
      if (idx === 1) {
        setTimeout(function () {
          customjs.slideInit('#review_thumlist', 0, false, 500, false, 'auto', 4);
        }, 400);
      }
    },
    // 문의하기
    openQnaInsertPop() {
      if (!JwtService.getToken()) {
        this.msg = LOGIN_REQUIRE;
        this.confirmPop = true;
        return false;
      }
      this.prodQna.productInfo.product.productCode = this.product.productCode;
      this.productQnaInsertPop = true;
    },
    btnShowReviewPhotoDetail(reviewIdx) {
      this.currentReviewPhotoIdx = reviewIdx;
      this.reviewPhotoPop = true;
      $('body').addClass('popOn');
    },
    closeReviewPhotoPop() {
      this.reviewPhotoPop = false;
      $('body').removeClass('popOn');
    },
    showReviewSinglePhoto(photoUrl) {
      this.reviewPhoto = photoUrl;
      this.reviewSinglePhotoPop = true;
      $('body').addClass('popOn');
    },
    closeReviewSinglePhotoPop() {
      this.reviewSinglePhotoPop = false;
      $('body').removeClass('popOn');
    },
    // 후기쓰기
    openReviewInsertPop() {
      if (!JwtService.getToken()) {
        this.msg = LOGIN_REQUIRE;
        this.confirmPop = true;
        return false;
      }
      // 상품 구매 체크
      ApiService.service('GET', '/user/auth/product/' + this.productCode)
        .then(({ data }) => {
          if (!data.result) {
            this.msg = `해당 상품을 이용하신<br>고객만 작성 가능합니다.`;
            this.messagePop = true;
          } else {
            this.myReviewInsertPop = true;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    // 상품 정보 더보기
    btnProductMore() {
      $('.detailWrap').attr('data-current', $(window).scrollTop());
      let currentY = $('.detailWrap').data('current');

      if ($('#prd_detail_more').parent().hasClass('on') == true) {
        $('.detailWrap').find('.inner').css('max-height', '870px');
        $('.detailWrap').removeClass('on');
        $('#prd_detail_more').children('span').html('상품정보 더보기');
      } else {
        $('.detailWrap').find('.inner').css('max-height', '100%');
        $('.detailWrap').addClass('on');
        $('#prd_detail_more').children('span').html('상품정보 접기');
      }

      $('html,body').scrollTop(currentY);
    },
    confirm() {
      this.$router.push({ name: 'login', params: { redirect: 'productDetail', param: { idx: this.product.productIndex } } });
    },
    qnaInsertPopClose() {
      this.productQnaInsertPop = false;
      this.selectQnaList(); // QnA 리스트 조회
    },
    // 이룸N렌탈 이벤트페이지로 이동
    sangjoEvent() {
      //, title: value.spEbTitle, img: value.spEbThumnail
      this.$router.push({ name: 'eventDetail', params: { idx: 101 } });
    },
  },
};
</script>